module.exports = __webpack_public_path__ + "static/media/react.8c1ef40d.jpg";